import { TFunction } from "react-i18next";
import { ListConfigField } from "go-list/core/services/types";

export const getConfigFieldsWithSummaryData = (
	t: TFunction,
	summaryFieldsConfig: Record<string, string | number | undefined>,
	fields?: ListConfigField[],
	summaryData?: Record<string, any>
) => {
	if (!summaryData || !fields) return fields;

	const newFields: ListConfigField[] = fields.map((field) => ({ ...field, renderSummary: () => "" }));
	newFields[0].renderSummary = () => `${t("common.word.summary", { ns: "lib" })} (${summaryData.count})`;

	const fieldsToBeModified = Object.entries(summaryFieldsConfig);

	fieldsToBeModified.forEach(([fieldId, fieldValue]) => {
		const fieldToBeModified = newFields.find((field) => field.id === fieldId);
		if (!fieldToBeModified) return;

		fieldToBeModified.renderSummary = () => fieldValue;
	});

	return newFields;
};
